import { render, staticRenderFns } from "./instructores.vue?vue&type=template&id=44b14701&scoped=true"
import script from "./instructores.vue?vue&type=script&lang=js"
export * from "./instructores.vue?vue&type=script&lang=js"
import style0 from "./instructores.vue?vue&type=style&index=0&id=44b14701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b14701",
  null
  
)

export default component.exports